<a (click)="searchResultClick(selectedJob)">
    <div class="left-column">
        <div class="job-title" [innerHtml]="job.jobTitle | safe: 'html'"></div>
        <div *ngIf="showDistance" class="distance hidden-xs">{{job.distance}} miles</div>
        <div class="location" [innerHtml]="buildAddressString(job) | safe: 'html'"></div>
        <div class="category" *ngIf="job.categories" [innerHtml]="buildCategoryString(job) | safe:'html'"></div>
        <div *ngIf="showShare" class="share-button hidden-xs"><share-button [job]="job" [themeColor]="themeColor"></share-button></div>
        <div *ngIf="showApply" class="apply-button">
            <apply-button [themeColor]="themeColor" [buttonText]="'Apply'"></apply-button>
        </div>
    </div>

    <div class="right-column">
        <div *ngIf="showDistance" class="distance"><strong>{{job.distance}}</strong><br/>miles</div>
        <div *ngIf="showShare" class="share-button-mobile"><share-button [job]="job" [themeColor]="themeColor" [useMobileButton]="true"></share-button></div>
    </div>
</a>
